// deps
import React, { memo, ReactElement } from "react";

// internal deps
import { AriaHidden } from "@swiggy-private/core-ui";
import { isNonEmptyString } from "@swiggy-private/payment-core";

// widgets
import { ArrowSvgIcon } from "@payment-ui/widgets/arrow-svg-icon";

//styles
import styles from "./OtherPaymentOffersGenericUI.scss";

interface Props {
    onClick: (e: React.MouseEvent) => void;
    displayName: string;
    subtext: string | undefined;
    paymentMethodIcon: ReactElement;
}

function OtherPaymentOffersGenericUI(props: Props): React.ReactElement {
    const { displayName, paymentMethodIcon, subtext, onClick } = props;

    const ariaLabelText = `${displayName}. ${isNonEmptyString(subtext) ? subtext : ""}`;

    return (
        <div className={styles.containerBorder} data-testId="other-offer-container" onClick={onClick}>
            <div className={styles.container}>
                {paymentMethodIcon}
                <div className={styles.containerTextWrapper} role="button" tabIndex={0} aria-label={ariaLabelText}>
                    <AriaHidden as="div" className={styles.containerText}>
                        {displayName}
                    </AriaHidden>
                    {isNonEmptyString(subtext) && (
                        <AriaHidden as="div" className={styles.containerSubtext}>
                            {subtext}
                        </AriaHidden>
                    )}
                </div>
                <AriaHidden as="div" className={styles.containerArrowIconWrapper}>
                    <ArrowSvgIcon className={styles.containerArrowIcon} />
                </AriaHidden>
            </div>
        </div>
    );
}

export default memo(OtherPaymentOffersGenericUI);
